import { render, staticRenderFns } from "./PersonBehaviorBarChart.vue?vue&type=template&id=23b56ae0&scoped=true"
import script from "./PersonBehaviorBarChart.vue?vue&type=script&lang=js"
export * from "./PersonBehaviorBarChart.vue?vue&type=script&lang=js"
import style0 from "./PersonBehaviorBarChart.vue?vue&type=style&index=0&id=23b56ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b56ae0",
  null
  
)

export default component.exports